<template>
  <div class="container">
    <h1>Pollstar Artist Search</h1>
    <div class="search-box">
      <input v-model="artistName" placeholder="Enter artist name" class="search-input" />
      <button @click="searchArtists" class="search-button">Search</button>
    </div>

    <ul class="artist-list">
      <li v-for="artist in artists" :key="artist.artistId" class="artist-item">
        <a :href="artist.url" target="_blank">{{ artist.artistName }}</a>
      </li>
    </ul>
    <div v-if="artists.length" class="results">
      <h4 class="textNews2">Results:</h4>
      <ul>
        <li v-for="(artist, index) in artists" :key="index" class="artist">
          <h3>{{ artist.artistName }}</h3>
          <p>Artist ID: {{ artist.artistId }}</p>
          <p>Genre: {{ artist.genre }}</p>
          <p>
            <a :href="artist.url" target="_blank" class="buttonNews">
              View on Pollstar
            </a>
          </p>
        </li>
      </ul>
    </div>
    <p v-else-if="loading">Loading...</p>
    <p v-else-if="error">{{ error }}</p>
    <!-- Search Results -->
    <div class="artist-list" v-if="artists.length">
      <h2>Search Results:</h2>
      <ul>
        <li v-for="artist in artists" :key="artist.id" @click="getArtistDetails(artist.id)">
          {{ artist.name }}
          {{ artist.genre }}
          <a :href="artist.url" target="_blank">View on Pollstar</a>
          
        </li>
      </ul>
    </div>

    <!-- Artist Details -->
    <div class="artist-details" v-if="artistDetails">
      <h2>Artist Details:</h2>
      <p><strong>Name:</strong> {{ artistDetails.name }}</p>
      <p><strong>Genre:</strong> {{ artistDetails.genres ? artistDetails.genres.join(', ') : 'N/A' }}</p>
      <p><strong>URL:</strong> <a :href="artistDetails.url" target="_blank">{{ artistDetails.url }}</a></p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      artistName: '',
      artists: [],
      artistDetails: null,
      accessToken: '',
    };
  },
  methods: {
    async getAccessToken() {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

  const urlencoded = new URLSearchParams();
  urlencoded.append("client_id", "3f6c44e53a4a44148b8c1dda9fddc229");
  urlencoded.append("client_secret", "NtU8Sodrnfa0XEwakwB7Da+NvuVURKVSzRIagGzJTcI=");
  urlencoded.append("grant_type", "client_credentials");

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: urlencoded,
    redirect: 'follow',
    mode: 'no-cors', // Add this line
  };

  try {
    const response = await fetch("https://data.pollstar.com/api/v3/token", requestOptions);
    console.log("Response:", response);
    // Note: You cannot access the response body in no-cors mode
  } catch (error) {
    console.error("Error:", error);
  }
},
    async searchArtists() {
      const accessToken = await this.getAccessToken();
      if (!accessToken) return;

      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${accessToken}`);
      myHeaders.append("Accept", "application/json");

      const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow',
      };

      try {
        const response = await fetch(
          `https://data.pollstar.com/api/v3/artists/search/${encodeURIComponent(this.artistName)}?page=0&pageSize=10`,
          requestOptions
        );
        const result = await response.json();
        this.artists = result.artists;
      } catch (error) {
        console.log('error', error);
      }
    },
  },
};
</script>

<style scoped>
.container {
  font-family: 'Arial', sans-serif;
  margin: 0 auto;
  max-width: 800px;
  padding: 20px;
  background: linear-gradient(145deg, #1d1f26, #282c34);
  border-radius: 15px;
  box-shadow: 5px 5px 15px rgba(0, 0, 0, 0.5), -5px -5px 15px rgba(60, 60, 60, 0.2);
  color: #ffffff;
  text-align: center;
}

h1 {
  margin-bottom: 20px;
  font-size: 2.5em;
  color: #61dafb;
}

.search-box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.search-input {
  width: 70%;
  padding: 10px;
  font-size: 1em;
  border: 2px solid #61dafb;
  border-radius: 5px 0 0 5px;
  outline: none;
  transition: 0.3s;
}

.search-input:focus {
  border-color: #21a1f1;
}

.search-button {
  padding: 10px 20px;
  font-size: 1em;
  background-color: #61dafb;
  color: #fff;
  border: none;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  transition: 0.3s;
}

.search-button:hover {
  background-color: #21a1f1;
}

.artist-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.artist-item {
  margin: 10px 0;
  font-size: 1.2em;
}

.artist-item a {
  color: #61dafb;
  text-decoration: none;
  transition: 0.3s;
}

.artist-item a:hover {
  color: #21a1f1;
}
</style>
